export default __webpack_public_path__ + "static/media/tick-circle.98652564.svg";